export default class Html {
  public static removeTags(value?: string) {
    if (value == null || value.length === 0) {
      return '';
    }

    return value.replace(/(<([^>]+)>)/ig, '');
  }
}
